import {
    AviationDocumentCategory,
    CategoryComplianceStats,
} from '@/features/end-of-lease/types';
import { Settings2 } from 'lucide-react';

import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';

import { useIATAFolders } from '../hooks/useIATAFolder';
import { IATAFolderCard } from './IATAFolderCard';

interface Props {
    complianceSummary?: CategoryComplianceStats[];
    navigateToFolder: (letter: string) => void;
}

export function IATABinder({ complianceSummary, navigateToFolder }: Props) {
    // Create folders for each category that has documents or is important to show
    const categoriesToShow: AviationDocumentCategory[] = [
        'Certificates',
        'MaintenanceStatusSummaries',
        'AircraftMaintenanceRecords',
        'ConfigurationStatus',
        'AircraftManufacturerRecords',
        'EngineRecords_1',
        'EngineRecords_2',
        'APURecords',
        'ComponentRecords',
        'LandingGearRecords',
        'Manuals',
        'Miscellaneous',
    ];
    const folders = useIATAFolders(categoriesToShow, complianceSummary);

    return (
        <Accordion
            type="single"
            defaultValue="iata-binder"
            collapsible
            className="w-full"
        >
            <AccordionItem value="iata-binder" className="border-none">
                <AccordionTrigger
                    className="px-6 py-4 hover:no-underline bg-muted/50 border-b"
                    data-testid="IATABinder"
                >
                    <div className="flex items-center justify-between w-full mr-4">
                        <div className="text-left">
                            <h2 className="text-xl font-bold text-foreground mb-1">
                                IATA Technical Binder
                            </h2>
                            <p className="text-muted-foreground text-sm">
                                Technical documentation organized by IATA Spec
                                2000 standards
                            </p>
                        </div>
                        <div className="flex items-center gap-3">
                            <Button
                                variant="outline"
                                size="sm"
                                className="h-8"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Settings2 className="h-3 w-3 mr-1.5" />
                                Customize
                            </Button>
                        </div>
                    </div>
                </AccordionTrigger>
                <AccordionContent className="px-6 py-6 bg-muted/30">
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                        {folders.map((folder) => (
                            <IATAFolderCard
                                navigateToFolder={navigateToFolder}
                                key={folder.letter}
                                folder={folder}
                            />
                        ))}
                    </div>
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    );
}
